import React from 'react';

interface ISvgIcon {
  color?: string;
  className: string;
}

const Share = ({color = "#FFF", className} : ISvgIcon) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="13.618" height="13.618" viewBox="0 0 13.618 13.618">
      <g id="share" transform="translate(0.25 0.25)">
        <path id="Path_3518" data-name="Path 3518" d="M159.572,0h-3.067a.308.308,0,0,0,0,.615h2.329l-5.983,6.04a.308.308,0,0,0,.437.433l5.976-6.033V3.374a.308.308,0,1,0,.615,0V.308A.308.308,0,0,0,159.572,0Zm0,0" transform="translate(-146.761)" fill={color} stroke={color} strokeWidth="0.5"/>
        <path id="Path_3519" data-name="Path 3519" d="M11.237,55.57a.347.347,0,0,0-.347.347v3.8a1.041,1.041,0,0,1-1.04,1.04H1.733a1.041,1.041,0,0,1-1.04-1.04V51.6a1.041,1.041,0,0,1,1.04-1.04h3.8a.347.347,0,1,0,0-.693h-3.8A1.735,1.735,0,0,0,0,51.6v8.117a1.735,1.735,0,0,0,1.733,1.733H9.851a1.735,1.735,0,0,0,1.733-1.733v-3.8A.347.347,0,0,0,11.237,55.57Zm0,0" transform="translate(0 -48.329)" fill={color} stroke={color} strokeWidth="0.5"/>
      </g>
    </svg>
  )
}

export default Share;